var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPanelAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 15.3C21.9227 15.3 19.8333 17.3595 19.8333 19.9C19.8333 22.4405 21.9227 24.5 24.5 24.5C27.0773 24.5 29.1667 22.4405 29.1667 19.9C29.1667 17.3595 27.0773 15.3 24.5 15.3ZM17.5 19.9C17.5 16.0892 20.634 13 24.5 13C28.366 13 31.5 16.0892 31.5 19.9C31.5 23.7108 28.366 26.8 24.5 26.8C20.634 26.8 17.5 23.7108 17.5 19.9ZM19.8333 31.4C17.9003 31.4 16.3333 32.9446 16.3333 34.85C16.3333 35.4851 15.811 36 15.1667 36C14.5223 36 14 35.4851 14 34.85C14 31.6744 16.6117 29.1 19.8333 29.1H29.1667C32.3883 29.1 35 31.6744 35 34.85C35 35.4851 34.4777 36 33.8333 36C33.189 36 32.6667 35.4851 32.6667 34.85C32.6667 32.9446 31.0997 31.4 29.1667 31.4H19.8333Z",
    fill: "#DCDEE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPanelAvatar);
export default __webpack_public_path__ + "static/media/user_panel_avatar.017c638594958155fca87f529416927e.svg";
export { ForwardRef as ReactComponent };